<script lang="ts">
</script>

<div class="suggestion-wrapper">
    <p class="option-no-result">Loading...</p>
</div>

<style>
    .suggestion-wrapper {
        @apply relative h-full overflow-y-auto overflow-x-hidden rounded-md border border-solid border-gray-200 bg-white p-1 text-black shadow !important;
    }

    .option-no-result {
        @apply my-0 w-full text-center !important;
    }
</style>
